/**
 * エラー画面のルーティング設定
 *   nameは原則としてパスと合わせること。
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
import { RouteConfig } from 'vue-router'

// 対象画面import
import ErrorAuth from '../views/error/ErrorAuth.vue'
import Error400 from '../views/error/Error400.vue'
import Error401 from '../views/error/Error401.vue'
import Error404 from '../views/error/Error404.vue'
import Error500 from '../views/error/Error500.vue'

/**
 * エラーページ群
 */
const errorRoutes: Array<RouteConfig> = [
  {
    path: '/error/auth',
    name: 'ErrorAuth',
    component: ErrorAuth,
  },
  {
    path: '/error/error400',
    name: 'Error400',
    component: Error400,
  },
  {
    path: '/error/error401',
    name: 'Error401',
    component: Error401,
  },
  {
    path: '/error/error404',
    name: 'Error404',
    component: Error404,
  },
  {
    path: '/error/error500',
    name: 'Error500',
    component: Error500,
  },
]

export default errorRoutes
